import { render, staticRenderFns } from "./DetailLaporanPemasukan.vue?vue&type=template&id=aec7fbe2&"
import script from "./DetailLaporanPemasukan.vue?vue&type=script&lang=js&"
export * from "./DetailLaporanPemasukan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports